function AllPersonalInvestorsChanged(e)
{
    if ($('#AllPotentialInvestors:checkbox:checked').length > 0) {
        $('#OtherPersonalInvestorsSelections :checkbox').removeAttr('checked');
    }    
};

function OtherPersonalInvestorsChanged(e)
{
    if ($('#OtherPersonalInvestorsSelections :checkbox:checked').length > 0) {
        $('#AllPotentialInvestors:checkbox').removeAttr('checked');
    }

    if ($('#OtherPersonalInvestorsSelections :checkbox:checked').length == 5) {
        $('#OtherPersonalInvestorsSelections :checkbox').removeAttr('checked');
        $('#AllPotentialInvestors:checkbox').prop('checked', true);
    }
}
